import { ReactComponent as IconClose } from "assets/icons/close.svg";
import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import * as S from "./style";

interface ModalProps {
  title?: string;
  visible: boolean;
  children?: React.ReactNode;
  okText?: string;
  cancelText?: string;
  onOk?: () => void;
  onCancel?: () => void;
  type?: "custom" | "notAction" | "loading" | "";
  disabled?: any;
  className?: any;
}

const Modal = ({
  visible,
  title,
  children,
  onOk,
  onCancel,
  cancelText,
  okText,
  type,
  disabled,
  className,
}: ModalProps) => {
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  function useOutsideAlerter(ref: any) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          onCancel?.();
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  return visible
    ? ReactDOM.createPortal(
        <>
          <S.ModalOverlay />
          <S.ModalWrapper aria-modal aria-hidden tabIndex={-1} role="dialog">
            {type === "loading" ? (
              children
            ) : (
              <S.Modal className={className} ref={wrapperRef}>
                <S.ModalHeader className={className}>
                  {onCancel && (
                    <S.ModalCloseButton
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => onCancel?.()}
                    >
                      <IconClose />
                    </S.ModalCloseButton>
                  )}
                </S.ModalHeader>
                <S.ModalContainer>
                  <S.ModalContent>{children}</S.ModalContent>
                  {/* { type === "notAction" ? (
                    <></>
                  ) : (
                    <S.ModalButton>
                      {onCancel &&
                      <S.ModalCancel onClick={() => onCancel?.()}>
                        {cancelText || t("MEMBERSHIP_POPUP_CANCEL")}
                      </S.ModalCancel>
                      }
                      {okText &&
                      <S.ModalConfirm onClick={() => onOk?.()}>
                        {okText || t("MEMBERSHIP_POPUP_OK")}
                      </S.ModalConfirm>
                      }
                    </S.ModalButton>
                  )} */}
                </S.ModalContainer>
              </S.Modal>
            )}
          </S.ModalWrapper>
        </>,
        document.body
      )
    : null;
};

export default Modal;
